// components/sales/sections/WebPerformance.jsx

import { memo, useMemo } from "react";
import GA4TrafficByChannel from './GA4TrafficByChannel';
import GSCPerformanceChart from './GSCPerformanceChart';

export const WebPerformance = memo(({ dateRange }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        {/* GA4 Traffic by Channel - Always renders independently */}
        <GA4TrafficByChannel dateRange={dateRange} />

        {/* GSC Performance Chart - Always renders independently */}
        <GSCPerformanceChart dateRange={dateRange} />
      </div>
    </div>
  );
});

export default WebPerformance;